<template>
  <div id="app">
    <div class="loading" v-if="isLoading">
      <img src="https://www.3dreal.com/assets/3dreal-loading.gif" />
    </div>
    <div class="bf-logo">
      <a href="https://www.3dreal.com/" target="_blank">
        <img src="https://www.3dreal.com/assets/3dreal-logo-blue@2x.png" />
      </a>
    </div>
    <div id="panorama"></div>
    <modal
      :title="title"
      :is-show="show"
      :show-ok="false"
      :show-footer="false"
      transition="fadeDown"
      @close="show = false"
    >
      <div style="height:100%">
        <iframe style="width: 100%;height:100%" :src="iframeSrc" />
      </div>
    </modal>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      show: false,
      title: "",
      iframeSrc: "",
      isLoading: true
    };
  },
  async mounted() {
    // eslint-disable-next-line no-undef
    await pannellum.viewer("panorama", {
      //Pannellum支持四种处理全景图片的方式：equirectangular,partial,cubic,multi-resolution
      panorama: "https://pannellum.org/images/tocopilla.jpg",
      // hotSpotDebug:true,
      sceneFadeDuration: 1000, //全景图场景切换时的持续时间
      autoLoad: true, //自动加载
      pitch: -13.393288042455284,
      yaw: 263,
      hfov: 100.0,
      type: "multires",
      multiRes: {
        basePath: "./image/img1",
        path: "/%l/%s%y_%x",
        fallbackPath: "/fallback/%s",
        extension: "jpg",
        tileResolution: 512,
        maxLevel: 4,
        cubeResolution: 2552
      },
      showControls: false, //是否显示控制按钮，默认true；
      autoRotate: -2, //是否自动旋转，在加载之后，全景图会水平旋转显示，负数为往右边旋转，整数为往左边旋转，值为数字类型；
      hotSpots: [
        // {
        //   pitch: -18.254943554243,
        //   yaw: -89.31114874435126,
        //   type: "info",
        //   cssClass: "shou1",
        //   text: "椰子鞋350真爆v2百满天1999.00",
        //   URL:
        //     "http://1215156752334843906.mobileshop.3dreal.com/dashboard/home/detail?id=1262294219248451586"
        // },
        {
          pitch: -14, //定位参数， 单位：角度
          yaw: 164, //定位参数， 单位：角度 y轴，空间中的纵轴
          type: "info", //热点类型，scene 场景切换热点； info 信息展示；URL 以热点为链接，跳转到其他页面的`url
          text: "返回潮包馆",
          cssClass: "arrow",
          URL: window.location.origin + '/home'
        }
      ]
    });
    window.addEventListener("load", ()=> {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    });
  }
};
</script>
<style>
.pnlm-ui .pnlm-about-msg {
  display: none !important;
}

.pnlm-ui .pnlm-orientation-button {
  display: none !important;
}
.pnlm-lmsg {
  display: none;
}
</style>
<style lang="less">
body {
  margin: 0;
  padding: 0;
}
#app {
  .bf-logo {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    img{
      height: 50px;
      width: 100%;
    }
    @media (max-width: 768px) {
      img{
        height: 30px;
        width: 100%;
      }
    }

  }
}
#panorama {
  height: 100vh;
}
.shou1 {
  background-image: url("../../assets/image/10.png");
  width: 50px;
  height: 50px;
  background-size: 50px 300px;
  animation: show1 0.3s infinite step-start;
}
@keyframes show1 {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: 0 -250px;
  }
  50% {
    background-position: 0 -150px;
  }
  75% {
    background-position: 0 -150px;
  }
  100% {
    background-position: 0 0;
  }
}
.arrow {
  background-image: url("../../assets/image/arrow.png");
  width: 64px;
  height: 64px;
  background-size: 64px 1600px;
  animation: arrow 0.8s infinite step-start;
}
@keyframes arrow {
  0% {
    margin-top: 0;
  }
  25% {
    margin-top: -5px;
  }
  50% {
    margin-top: -10px;
  }
  75% {
    margin-top: -15px;
  }
  100% {
    margin-top: -20px;
  }
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 100;
  background-color: #fff;
  img {
    width: 22%;
    height: auto;
  }
}
</style>
